import { FC, HTMLAttributes } from "react";
import clsx from "classnames";
import { Typography } from "../../core/Typography/Typography";
import { Button } from "../../core/Button/Button";
import {
  TypographyColor,
  TypographyVariant,
} from "../../../constants/typography";
import { useTranslation } from "react-i18next";
import { useStyles } from "./NoInternet.style";

export const NoInternet: FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const classes = useStyles();
  const { className, ...otherProps } = props;
  const { t } = useTranslation();

  const reloadPage = () => {
    window.location.href = "/";
  };

  return (
    <div {...otherProps} className={clsx(classes.root, className)}>
      <Typography variant={TypographyVariant.HeadingH5Bold}>
        {t("common_Whoops")}
      </Typography>
      <Typography
        variant={TypographyVariant.BodyB5Regular}
        color={TypographyColor.Silver}
        className={classes.description}
      >
        {t(
          "common_No internet connection! Make sure wifi or cellular data is turned on.",
        )}
      </Typography>
      <Button
        variant="contained"
        className={classes.button}
        onClick={reloadPage}
      >
        <Typography variant={TypographyVariant.BodyB5Bold}>
          {t("Refresh")}
        </Typography>
      </Button>
    </div>
  );
};
